import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from 'react-icons/fa'
import { useParams } from "react-router-dom";
import Banner from "../components/Banner";
import jobsData from "../data/JobsData";
import { motion, AnimatePresence } from "framer-motion";
import {
    FaBriefcase,
    FaMapMarkerAlt,
    FaClipboardList,
    FaCheckCircle,
    FaStar,
    FaFileUpload
} from "react-icons/fa";

import "../styles/pages/JobDetails.css";
import JobsBanner from '../images/career-bg.jpeg'

const JobDetails = () => {



    const { id } = useParams();
    const job = jobsData.find(j => j.id === id);

    const [showForm, setShowForm] = useState(false);

    if (!job) {
        return <h2>Job Not Found</h2>
    }
    const fadeUp = {
        hidden: { opacity: 0, y: 50 },
        show: {
            opacity: 1, y: 0,
            transition: { duration: 0.7, ease: "easeOut" }
        }
    };



    return (

        <div>

            <Banner title={job.title} image={JobsBanner} />

            <div className="job-details-main py-5">

                <div className="job-details-wrapper container pb-5">

                    {/* HEADER */}

                    <div className="job-title-row">

                        <div>

                            <h2>{job.title}</h2>

                            <div className="job-meta">

                                <span>
                                    <FaMapMarkerAlt /> {job.location}
                                </span>

                                <span>
                                    <FaBriefcase /> {job.type}
                                </span>

                            </div>

                        </div>


                        <motion.button
                            className="apply-big-btn"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => setShowForm(true)}
                        >

                            Apply Now

                        </motion.button>


                    </div>

                    {/* <motion.div
                        className="filter-mobile-btn"
                        variants={fadeUp}
                    >

                        <button
                            className="filter-btn"
                            onClick={() => setShowForm(true)}
                        >

                            <FaClipboardList className="me-2" />

                            Filter / Apply

                        </button>

                    </motion.div> */}

                    <motion.div
                        className="row"
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, margin: "-80px" }}
                    >


                        {/* LEFT SIDE */}

                        <motion.div
                            className="col-lg-8"
                            variants={fadeUp}
                        >

                            <motion.div
                                className="job-card"
                                variants={fadeUp}
                            >

                                <h3>
                                    <FaClipboardList />
                                    Job Description
                                </h3>

                                <p>{job.description}</p>

                            </motion.div>



                            <motion.div
                                className="job-card"
                                variants={fadeUp}
                                transition={{ delay: 0.1 }}
                            >

                                <h3>
                                    <FaCheckCircle />
                                    Responsibilities
                                </h3>

                                <ul>
                                    {job.responsibilities.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>

                            </motion.div>



                            <motion.div
                                className="job-card"
                                variants={fadeUp}
                                transition={{ delay: 0.2 }}
                            >

                                <h3>
                                    <FaCheckCircle />
                                    Requirements
                                </h3>

                                <ul>
                                    {job.requirements.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>

                            </motion.div>



                            {job.preferred && (

                                <motion.div
                                    className="job-card"
                                    variants={fadeUp}
                                    transition={{ delay: 0.3 }}
                                >

                                    <h3>
                                        <FaStar />
                                        Preferred Skills
                                    </h3>

                                    <ul>
                                        {job.preferred.map((item, i) => (
                                            <li key={i}>{item}</li>
                                        ))}
                                    </ul>

                                </motion.div>

                            )}



                            {/* Bottom Apply Button */}

                            <motion.div
                                className="bottom-apply"
                                variants={fadeUp}
                                transition={{ delay: 0.4 }}
                            >

                                <button
                                    className="apply-big-btn"
                                    onClick={() => setShowForm(true)}
                                >

                                    Apply Now

                                </button>

                            </motion.div>


                        </motion.div>



                        {/* RIGHT SIDE FORM */}

                        <motion.div
                            className={`col-lg-4 sidebar-col ${showForm ? "open" : ""}`}
                            variants={fadeUp}
                        >

                            <div className="sidebar-form">

                                {/* Cancel Button */}

                                <div
                                    className="sidebar-close d-lg-none"
                                    onClick={() => setShowForm(false)}
                                >
                                    ✕
                                </div>

                                <h3>Apply Now</h3>

                                <form>

                                    <input type="text" placeholder="Name" required />

                                    <input type="email" placeholder="E-Mail" required />

                                    <input type="tel" placeholder="Phone Number" required />

                                    <input type="text" placeholder="Qualification" required />

                                    <input type="text" placeholder="City" required />

                                    <input type="text" placeholder="Country" required />

                                    <input type="file" required />

                                    <textarea placeholder="Subject" rows="4" required></textarea>

                                    <button type="submit" className="submit-btn">
                                        Submit Application
                                    </button>

                                </form>

                            </div>

                        </motion.div>


                    </motion.div>

                </div>



                {/* POPUP FORM */}

                <AnimatePresence>

                    {showForm && (

                        <motion.div
                            className="popup-overlay"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                        >

                            <motion.div
                                className="popup-form"
                                initial={{ scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                exit={{ scale: 0.8, opacity: 0 }}
                            >

                                {/* Close Icon */}

                                <div
                                    className="popup-close"
                                    onClick={() => setShowForm(false)}
                                >

                                    <svg
                                        width="22"
                                        height="22"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M18 6L6 18M6 6L18 18"
                                            stroke="#333"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                        />
                                    </svg>

                                </div>



                                <h3>Apply For This Job</h3>


                                <form>

                                    <input
                                        type="text"
                                        placeholder="Full Name"
                                        required
                                    />

                                    <input
                                        type="email"
                                        placeholder="Email"
                                        required
                                    />

                                    <input
                                        type="tel"
                                        placeholder="Phone"
                                        required
                                    />


                                    <div className="file-upload">

                                        <FaFileUpload />

                                        <input
                                            type="file"
                                            required
                                        />

                                    </div>



                                    <button
                                        type="submit"
                                        className="submit-btn full-btn"
                                    >

                                        Submit

                                    </button>


                                </form>

                            </motion.div>

                        </motion.div>

                    )}

                </AnimatePresence>

                {/* ===== CTA SECTION ===== */}
                <section className="about-cta-section">
                    <motion.div
                        className="container"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, margin: "-80px" }}
                    >
                        <h2>Let Us Help Your Business Move Forward</h2>
                        <p>
                            Fortune Cloud Solutions provides tailored IT staffing, industry-relevant training,
                            and career development services, empowering businesses and professionals to thrive
                            in the ever-evolving IT landscape.
                        </p>
                        <Link to="/contact">
                            <button className="about-cta-btn">
                                Get In Touch <FaArrowRight className="ms-2" />
                            </button>
                        </Link>
                    </motion.div>
                </section>
            </div>

        </div>

    );

};

export default JobDetails;